import React from 'react';
import { TrendingUp, Users, Package, Smile } from 'lucide-react';

const Achievements = () => {
  const stats = [
    { icon: Smile, value: '99%', label: 'Customer Satisfaction', color: 'from-green-500 to-emerald-600' },
    { icon: Package, value: '32M+', label: 'Shipments Delivered', color: 'from-blue-500 to-cyan-600' },
    { icon: Users, value: '125+', label: 'Expert Team Members', color: 'from-purple-500 to-pink-600' },
    { icon: TrendingUp, value: '240%', label: 'Annual Growth Rate', color: 'from-blue-700 to-red-600' }
  ];

  return (
    <section className="relative py-24 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 overflow-hidden">
      {/* Decorative Background */}
      <div className="absolute inset-0">
        {/* Grid pattern */}
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(rgba(59, 130, 246, 0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(59, 130, 246, 0.05) 1px, transparent 1px)',
          backgroundSize: '60px 60px'
        }}></div>
        
        {/* Glowing orbs */}
        <div className="absolute top-1/4 left-10 w-64 h-64 bg-gradient-to-br from-blue-700/20 to-blue-800/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-10 w-80 h-80 bg-gradient-to-br from-blue-500/20 to-blue-700/10 rounded-full blur-3xl"></div>
        
        {/* Geometric shapes */}
        <div className="absolute top-20 right-1/4 w-32 h-32 border border-blue-700/20 rounded-lg rotate-12"></div>
        <div className="absolute bottom-20 left-1/4 w-24 h-24 border border-blue-500/20 rounded-full"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-blue-500 font-semibold text-sm uppercase tracking-wide">Our Impact</span>
          <h2 className="text-4xl md:text-5xl font-bold mt-2 mb-4 text-white">
            Delivering <span className="bg-gradient-to-r from-blue-500 to-blue-800 bg-clip-text text-transparent">Excellence</span>
          </h2>
          <p className="text-gray-300 max-w-2xl mx-auto">
            Numbers that showcase our commitment to quality and growth
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div 
                key={index} 
                className="relative group"
              >
                {/* Card background with gradient border effect */}
                <div className="absolute inset-0 bg-gradient-to-r ${stat.color} rounded-2xl opacity-0 group-hover:opacity-100 blur transition-opacity duration-300"></div>
                
                <div className="relative bg-gray-800/90 backdrop-blur-sm p-8 rounded-2xl border border-gray-700 group-hover:border-blue-700/50 transition-all duration-300">
                  <div className={`w-14 h-14 bg-gradient-to-br ${stat.color} rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                    <Icon className="w-7 h-7 text-white" />
                  </div>
                  <div className={`text-5xl font-bold mb-2 bg-gradient-to-br ${stat.color} bg-clip-text text-transparent`}>
                    {stat.value}
                  </div>
                  <div className="text-gray-300 font-medium">{stat.label}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Achievements;